const FALLBACK_SITE_URL = "https://uxd.com";
const DEFAULT_META_IMAGE = "/assets/icons/favicon/android-chrome-512x512.png";

export const siteIcons = {
    icon: [
        { url: "/assets/icons/favicon/favicon-32x32.png", type: "image/png", sizes: "32x32" },
        { url: "/assets/icons/favicon/favicon-16x16.png", type: "image/png", sizes: "16x16" },
    ],
    apple: "/assets/icons/favicon/apple-touch-icon.png",
    shortcut: "/assets/icons/favicon/favicon.ico",
    other: [{ rel: "manifest", url: "/assets/icons/favicon/site.webmanifest" }],
};

export function getSiteUrl() {
    return (process.env.ACTUAL_URL || FALLBACK_SITE_URL).replace(/\/+$/, "");
}

export function normalizePath(path = "/") {
    if (!path || path === "/") {
        return "/";
    }

    const withLeadingSlash = path.startsWith("/") ? path : `/${path}`;
    return withLeadingSlash.replace(/\/+$/, "");
}

export function absoluteUrl(path = "/") {
    const normalizedPath = normalizePath(path);
    return normalizedPath === "/" ? getSiteUrl() : `${getSiteUrl()}${normalizedPath}`;
}

export function stripHtml(value = "") {
    return String(value)
        .replace(/<style[^>]*>.*?<\/style>/gis, " ")
        .replace(/<script[^>]*>.*?<\/script>/gis, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, " ")
        .trim();
}

export function truncateMetaText(value = "", maxLength = 160) {
    if (value.length <= maxLength) {
        return value;
    }

    const truncated = value.slice(0, maxLength + 1);
    const lastSpace = truncated.lastIndexOf(" ");

    return `${(lastSpace > 80 ? truncated.slice(0, lastSpace) : truncated.slice(0, maxLength)).trim()}...`;
}

export function resolveUrl(value = "/") {
    if (/^https?:\/\//i.test(value)) {
        return value;
    }

    return absoluteUrl(value);
}

export function buildPageMetadata({
    title,
    description,
    path = "/",
    index = true,
    follow = true,
    image = DEFAULT_META_IMAGE,
}) {
    const cleanDescription = truncateMetaText(stripHtml(description));
    const url = absoluteUrl(path);
    const imageUrl = resolveUrl(image);

    return {
        title,
        description: cleanDescription,
        alternates: {
            canonical: url,
        },
        icons: siteIcons,
        robots: {
            index,
            follow,
        },
        openGraph: {
            title,
            description: cleanDescription,
            url,
            type: "website",
            siteName: "Ultra-X Diagnostics",
            images: [
                {
                    url: imageUrl,
                    alt: title,
                },
            ],
        },
        twitter: {
            card: "summary",
            title,
            description: cleanDescription,
            images: [imageUrl],
        },
    };
}
